import Navbar from "../components/Navbar";
import Header from "../components/Header";
import {
  OurServices,
  Statistics,
  AboutUs,
  BrowseCategory,
  TopTranslators,
  GetStarted,
  GetInTouch,
  Testimonial,
  HowItWorks,
} from "../components/LandingSections";
import OurPartners from "../components/OurPartners";
import Footer from "../components/Footer";
const LandingPage = () => {
  return (
    <>
      <Navbar />
      <Header />
      <OurServices />
      <Statistics />
      <AboutUs />
      <BrowseCategory />
      <HowItWorks />
      <Testimonial />
      <TopTranslators />
      <GetStarted />
      <OurPartners />
      <GetInTouch />
      <Footer />
    </>
  );
};

export default LandingPage;
